export default __webpack_public_path__ + "static/media/imageFour.a8f56be2.svg";